import { Injectable } from '@angular/core';

/** Techniki pokazywania listy, która się jeszcze ładuje. */
export type ListLoadingStyle = 'skeleton' | 'spinner';

/**
 * Jedno miejsce decydujące, JAK aplikacja pokazuje ładujące się listy.
 *
 * Powstało po to, żeby zmiana techniki była jedną linią zamiast kwerendy po szablonach.
 * Sposób ładowania był wcześniej rozstrzygany osobno w każdym widoku — 41 wystąpień
 * `ngx-loading` w trzech różnych konfiguracjach — i nie dało się go zmienić inaczej niż
 * ręcznie, miejsce po miejscu. Przed oczami mieliśmy przy tym żywy kontrprzykład:
 * przełącznik ciemnego motywu siedzi w `app.component.ts`, a konsumenci sprawdzają go
 * przez `document.body.classList.contains('dark-mode')` w czterech różnych plikach.
 *
 * Świadome ograniczenie: to jest przełącznik, a nie architektura wtyczek. Dołożenie
 * trzeciej techniki wymaga nowej wartości w `ListLoadingStyle` i nowej gałęzi w
 * `ListStateComponent`. Wariant z `InjectionToken` i `ngComponentOutlet` dawałby
 * podmienialne implementacje bez dotykania komponentu, ale to spora maszyneria pod
 * przełącznik o dwóch wartościach. Refaktor w tę stronę będzie łatwy właśnie dlatego,
 * że wszyscy konsumenci pytają już o zdanie ten serwis, a nie własny szablon.
 *
 * Kto renderuje: `ListStateComponent` (`<app-list-state>`).
 * Kto dostarcza stan: `PagedList` — gettery `isInitialLoad`, `isEmpty`, `error`.
 */
@Injectable({ providedIn: 'root' })
export class ListPresentationService {

  /**
   * Technika dla wszystkich list w aplikacji. Zmiana tej jednej wartości przestawia
   * każdy `<app-list-state>` naraz — to cały mechanizm przełączania.
   */
  readonly loadingStyle: ListLoadingStyle = 'skeleton';
}
